import moment from "moment";
const wx = require('weixin-js-sdk');
export default {
    mounted() {
		let html = document.getElementsByTagName('html')[0];
		let page = document.getElementsByTagName('body')[0];
		setTimeout(() => {
			html.scrollTop = 0;
			page.scrollTop = 0;
		}, 0);
	},
    methods: {
         $timeFormat(time: string, format: string) {
            if (!time) return
            return moment(time).format(format);
        },


         $highlightTitle(title:any, highlight:any) {
            if (highlight && title) {
                const reg = new RegExp(this.escapeRegExp(highlight), "g");
                return `${title}`.replace(
                    reg,
                    `<span style="color: #991d85;">${highlight}</span>`
                );
            }
            return title;
        },
         escapeRegExp(string:string) {
            let newString = `${string}`;
            if (newString) {
                return newString.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
            }
            return string;
        },
        initShare(data = {}) {
			// 分享路径为首页
			// const _url = window.location.href.split('?')[0];
			const _url = window.location.href;
			var shareData;
			const env: any = process.env.VUE_APP_BLUE_DOT;
			const suffix: any = env === 'develop' ? `（测试）` : ``;
			if (JSON.stringify(data) == '{}') {
				shareData = {
					title: document.title, //标题
					desc: '耐恒', //简介
					link: `${_url}`, // 如果页面链接有其他参数需要自己拼接。
					imgUrl: 'https://loparex.oss-cn-shanghai.aliyuncs.com/minisite/loparex-share.png'
				};
			} else {
				shareData = data;
			}

			wx.ready(function () {
				const prefix = shareData.link.includes('?') ? '&' : '?';
				// shareData.link = shareData.link + prefix;

				// 分享到朋友圈（旧）
				wx.onMenuShareTimeline({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
				// 分享到朋友圈（新）
				wx.updateTimelineShareData({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});

				// 分享给朋友(旧)
				wx.onMenuShareAppMessage({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
				// 分享给朋友(新)
				wx.updateAppMessageShareData({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
			});
		},
		bodyOpen() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = '';
		},
		bodyClose() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = 'hidden';
		}
    }
}



